module.exports = __webpack_public_path__ + "img/Expo_Topic5.85f8e16d.png";